import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function instructorReducer(state = initialState.instructor, action) {
    switch(action.type){
        case types.SET_INSTRUCTOR:
            //debugger;
            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new state
            //console.log(`instructorReducer`,action.instructor);
            return Object.assign({},action.instructor);

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/instructorReducer.js
 **/